const ASSET_BASE = "/img";

export const SITE = {
  name: "Toronto Custom Signs & Wraps",
  shortName: "TCSW",
  legalName: "Toronto Custom Signs & Wraps",
  url: "https://tcsignsandwraps.com",
  phone: "+1 (289) 205-3623",
  phoneHref: "tel:+12892053623",
  phoneClean: "+12892053623",
  email: "torontocustomt@gmail.com",
  emailHref: "mailto:torontocustomt@gmail.com",
  instagram: "@toronto_teesandsigns",
  instagramUrl: "https://instagram.com/toronto_teesandsigns",
  gbpUrl: "https://share.google/A2KN0h9QcjyFHFYZE",
  gbpReviewUrl: "https://g.page/r/CRpShv86H-rnEBM/review",
  website: "tcsignsandwraps.com",
  areas: ["Toronto", "Mississauga", "Brampton", "Vaughan", "Markham", "Scarborough", "North York", "Etobicoke"],
  address: {
    locality: "Toronto",
    region: "ON",
    country: "CA",
  },
  geo: { lat: 43.6532, lng: -79.3832 },
  foundingYear: 2018,
};

// Image URLs (real client photos)
export const HERO_IMAGE = `${ASSET_BASE}/k4altnxn_20241217_032642_0aafb836.jpg`;
export const ABOUT_IMAGE = `${ASSET_BASE}/9h5z9lk7_20250829_193409.jpg`;

export const BEFORE_AFTER = [
  {
    before: `${ASSET_BASE}/abrj8q6i_20251021_130603.jpg`,
    after: `${ASSET_BASE}/g4ybn54p_20251020_114335.jpg`,
    beforeLabel: "Before",
    afterLabel: "After",
  },
  {
    before: `${ASSET_BASE}/a1ar1qkv_20251018_045545.jpg`,
    after: `${ASSET_BASE}/yoxwa7bj_20251017_102941.jpg`,
    beforeLabel: "Before",
    afterLabel: "After",
  },
];

export const SERVICES = [
  {
    slug: "architectural-wraps",
    title: "Architectural Wraps",
    short: "Cabinet, elevator, wall & retail wraps",
    intro: "Transform cabinets, walls, elevators, desks, retail interiors, and commercial spaces using premium architectural vinyl wraps.",
    image: `${ASSET_BASE}/9h5z9lk7_20250829_193409.jpg`,
    gallery: [
      `${ASSET_BASE}/9h5z9lk7_20250829_193409.jpg`,
      `${ASSET_BASE}/kpuw7xpa_20240703_002037_img_2080.jpg`,
      `${ASSET_BASE}/9mjfqate_20251018_045622.jpg`,
    ],
    includes: ["Cabinet wraps", "Elevator wraps", "Retail transformations", "Commercial interiors", "Surface refinishing", "Custom textures & finishes"],
  },
  {
    slug: "signs",
    title: "Custom Signs",
    short: "ACM, channel letters, dimensional & more",
    intro: "Professional indoor and outdoor signage solutions for businesses, offices, retail stores, and commercial properties.",
    image: `${ASSET_BASE}/smcw77sw_20260112_170103.jpg`,
    gallery: [
      `${ASSET_BASE}/smcw77sw_20260112_170103.jpg`,
      `${ASSET_BASE}/pato6h9a_20251222_191420.jpg`,
      `${ASSET_BASE}/nlkkgbhh_20251222_172745.jpg`,
      `${ASSET_BASE}/q8fd0ekt_20251219_182104.jpg`,
      `${ASSET_BASE}/esjozl7j_20250821_194526.jpg`,
    ],
    includes: ["ACM signs", "Channel letters", "Storefront signage", "Acrylic signs", "PVC signs", "Reception signs", "Wayfinding signage", "Dimensional lettering"],
  },
  {
    slug: "window-graphics",
    title: "Window Graphics & Frosted Film",
    short: "Privacy, branding, one-way vision",
    intro: "Custom window vinyl, privacy film, storefront graphics, perforated one-way vision, and frosted film installation.",
    image: `${ASSET_BASE}/jl7hpxzp_20260129_102049.jpg`,
    gallery: [
      `${ASSET_BASE}/jl7hpxzp_20260129_102049.jpg`,
      `${ASSET_BASE}/s8b4shg7_20251106_173215.jpg`,
      `${ASSET_BASE}/43wjj04a_20250327_144006_0b043744.jpg`,
      `${ASSET_BASE}/lwmtusog_20250304_093152_3f4de1ca.jpg`,
      `${ASSET_BASE}/o0lvweil_20250221_134259_575decc3.jpg`,
    ],
    includes: ["Frosted privacy film", "Storefront graphics", "Window decals", "One-way vision film", "Office branding", "UV protection film"],
  },
  {
    slug: "wall-graphics",
    title: "Wall & Floor Graphics",
    short: "Murals, decals, directional graphics",
    intro: "High-impact vinyl graphics for offices, retail stores, gyms, events, and commercial interiors.",
    image: `${ASSET_BASE}/4tydd9ob_20260129_053142.jpg`,
    gallery: [
      `${ASSET_BASE}/4tydd9ob_20260129_053142.jpg`,
      `${ASSET_BASE}/6bclknd3_20251017_195631.jpg`,
      `${ASSET_BASE}/jpe3n2vn_20251021_130630.jpg`,
      `${ASSET_BASE}/18dtyz63_20250829_191928.jpg`,
      `${ASSET_BASE}/2qiqmusz_20230919_121847_img_2886.jpg`,
    ],
    includes: ["Wall murals", "Branding graphics", "Floor decals", "Directional graphics", "Promotional graphics", "Interior branding"],
  },
  {
    slug: "installation",
    title: "Vinyl Installation Services",
    short: "Certified pro installation team",
    intro: "Professional installation for signs, wraps, wall graphics, and commercial vinyl applications.",
    image: `${ASSET_BASE}/tfjfxym9_20260504_131857_f87938bd.jpg`,
    gallery: [
      `${ASSET_BASE}/tfjfxym9_20260504_131857_f87938bd.jpg`,
      `${ASSET_BASE}/plzwj8k5_20260129_101733.jpg`,
      `${ASSET_BASE}/d3ygi2tt_20251111_143405.jpg`,
      `${ASSET_BASE}/urxjzcbp_20251020_144546.jpg`,
      `${ASSET_BASE}/0qwwd3p1_20250821_183031.jpg`,
    ],
    includes: ["Commercial installations", "Site measurements", "Surface prep", "Vinyl removal", "Re-installation", "Maintenance support"],
  },
];

// Curated gallery mix (categorized for the gallery filter UI)
export const GALLERY = [
  // Signs
  { src: `${ASSET_BASE}/smcw77sw_20260112_170103.jpg`, cat: "Signs", title: "Storefront signage" },
  { src: `${ASSET_BASE}/sjjur2wr_20251222_172745.jpg`, cat: "Signs", title: "MedCare Clinics interior sign" },
  { src: `${ASSET_BASE}/pato6h9a_20251222_191420.jpg`, cat: "Signs", title: "Custom dimensional sign" },
  { src: `${ASSET_BASE}/q8fd0ekt_20251219_182104.jpg`, cat: "Signs", title: "Reception signage" },
  { src: `${ASSET_BASE}/esjozl7j_20250821_194526.jpg`, cat: "Signs", title: "Commercial signage" },
  { src: `${ASSET_BASE}/9kdis137_20251106_170645.jpg`, cat: "Signs", title: "Custom acrylic sign" },

  // Wraps
  { src: `${ASSET_BASE}/9h5z9lk7_20250829_193409.jpg`, cat: "Wraps", title: "Architectural wrap install" },
  { src: `${ASSET_BASE}/kpuw7xpa_20240703_002037_img_2080.jpg`, cat: "Wraps", title: "Retail interior wrap" },
  { src: `${ASSET_BASE}/9mjfqate_20251018_045622.jpg`, cat: "Wraps", title: "Custom surface wrap" },

  // Window
  { src: `${ASSET_BASE}/jl7hpxzp_20260129_102049.jpg`, cat: "Window", title: "Frosted privacy film" },
  { src: `${ASSET_BASE}/s8b4shg7_20251106_173215.jpg`, cat: "Window", title: "Office window graphics" },
  { src: `${ASSET_BASE}/mrrsw3ac_20240419_140925_img_0940.jpg`, cat: "Window", title: "Frosted glass partition" },
  { src: `${ASSET_BASE}/lwmtusog_20250304_093152_3f4de1ca.jpg`, cat: "Window", title: "Storefront window decal" },
  { src: `${ASSET_BASE}/atezlhe8_20240613_140112_img_1799.jpg`, cat: "Window", title: "Retail window graphic" },
  { src: `${ASSET_BASE}/o0lvweil_20250221_134259_575decc3.jpg`, cat: "Window", title: "One-way vision film" },

  // Wall
  { src: `${ASSET_BASE}/4tydd9ob_20260129_053142.jpg`, cat: "Wall", title: "Branded wall graphics" },
  { src: `${ASSET_BASE}/6bclknd3_20251017_195631.jpg`, cat: "Wall", title: "Interior wall mural" },
  { src: `${ASSET_BASE}/jpe3n2vn_20251021_130630.jpg`, cat: "Wall", title: "Office wall branding" },
  { src: `${ASSET_BASE}/1zewveem_20240813_032221_img_2309.jpg`, cat: "Wall", title: "Heritage feature mural" },
  { src: `${ASSET_BASE}/2qiqmusz_20230919_121847_img_2886.jpg`, cat: "Wall", title: "Commercial wall graphics" },

  // Installation
  { src: `${ASSET_BASE}/tfjfxym9_20260504_131857_f87938bd.jpg`, cat: "Installation", title: "On-site install" },
  { src: `${ASSET_BASE}/plzwj8k5_20260129_101733.jpg`, cat: "Installation", title: "Commercial install" },
  { src: `${ASSET_BASE}/d3ygi2tt_20251111_143405.jpg`, cat: "Installation", title: "Signage installation" },
  { src: `${ASSET_BASE}/urxjzcbp_20251020_144546.jpg`, cat: "Installation", title: "Channel letter mount" },
  { src: `${ASSET_BASE}/0qwwd3p1_20250821_183031.jpg`, cat: "Installation", title: "Storefront install" },
];

export const TESTIMONIALS = [
  { quote: "Professional installation and amazing attention to detail. Our office looks completely transformed.", author: "Daniel R.", role: "Operations Director, Mississauga" },
  { quote: "Fast turnaround and excellent communication from start to finish. They handled everything seamlessly.", author: "Priya S.", role: "Retail Manager, Toronto" },
  { quote: "High-quality wraps and signage. Highly recommended for commercial projects.", author: "Marcus L.", role: "Property Manager, Vaughan" },
];

export const PROCESS = [
  { n: "01", title: "Consultation", text: "Tell us about your project, measurements, and vision. We listen first." },
  { n: "02", title: "Mockup & Quote", text: "We provide a professional quote and a visual mockup before you commit." },
  { n: "03", title: "Production", text: "Your graphics and materials are precision-produced in-house." },
  { n: "04", title: "Installation", text: "Our certified team completes a clean, professional install on-site." },
];
